import { createRoot } from "react-dom/client";
import PrescriptionPrint from "./PrescriptionPrint";

const handlePrintPrescription = (appointmentId) => {
  const printWindow = window.open("", "_blank", "width=800,height=600");

  if (printWindow) {
    printWindow.document.write(`
      <html>
        <head>
          <title>Prescription Print</title>
          <style>
            body { margin: 20px; font-family: Arial, sans-serif; }
          </style>
        </head>
        <body>
          <div id="print-root"></div>
        </body>
      </html>
    `);

    printWindow.document.close();

    const interval = setInterval(() => {
      const rootDiv = printWindow.document.getElementById("print-root");
      if (rootDiv) {
        clearInterval(interval);
        const root = createRoot(rootDiv);
        root.render(<PrescriptionPrint appointmentId={appointmentId} printWindow={printWindow}/>);
      }
    }, 100);
  }
};

export default handlePrintPrescription;
